export function highlightProfileRow(profileId, options = {}) {
  if (!profileId) return undefined;

  const rowId = `profile-row-${profileId}`;
  const delayMs = options.delayMs ?? 250;
  const highlightMs = options.highlightMs ?? 3200;

  const timer = window.setTimeout(() => {
    const row = document.getElementById(rowId);
    if (!row) return;
    row.scrollIntoView({ behavior: 'smooth', block: 'center' });
    row.classList.add('hr-profile-row-highlight');
    window.setTimeout(() => row.classList.remove('hr-profile-row-highlight'), highlightMs);
  }, delayMs);

  return () => window.clearTimeout(timer);
}
